require("core-js/modules/es6.array.reduce.js");

exports.reduce = require('rxjs/internal/operators/reduce').reduce;